import { render, staticRenderFns } from "./TargetSystem.vue?vue&type=template&id=284f7595&scoped=true&"
import script from "./TargetSystem.vue?vue&type=script&lang=js&"
export * from "./TargetSystem.vue?vue&type=script&lang=js&"
import style0 from "./TargetSystem.vue?vue&type=style&index=0&id=284f7595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f7595",
  null
  
)

export default component.exports